import { ReportFilterOperation, ReportValue } from '@driftt/api-types'

import { isNilOrEmpty } from 'utils/ramda'

import { filterCreator } from '../query/creators'
import QueryBuilder from '../query/QueryBuilder'

const FILTER_BY_OPTIONS = Object.freeze({
  agentsSelected: filterCreator('agentId', ReportFilterOperation.IN),
})

export const filterForType = (
  filterType: string,
  filterValue: ReportValue | ReportValue[]
) => FILTER_BY_OPTIONS[filterType](filterValue)

export default class CallSummaryQueryBuilder extends QueryBuilder {
  public size: number
  public offset: number
  public page: number

  constructor(startDate, endDate) {
    super()
    this.size = 10
    this.offset = 0
    this.page = 1
    this.filters.push({
      property: 'createdAtDate',
      operation: ReportFilterOperation.BETWEEN,
      values: [startDate, endDate],
    })
  }
  public withFilters(q) {
    if (q.workspaceAgents && !isNilOrEmpty(q.workspaceAgents)) {
      this.withFilterType('agentsSelected', q.workspaceAgents)
    }
    if (q.teamSelected && !isNilOrEmpty(q.teamSelected)) {
      this.withFilterType('agentsSelected', q.teamSelected.members)
    }
    if (q.agentsSelected && !isNilOrEmpty(q.agentsSelected)) {
      this.withFilterType(
        'agentsSelected',
        q.agentsSelected.map((agent) => agent.value)
      )
    }
    return this
  }
  public withFilterType(type, value) {
    if (!value) {
      return this
    }
    this.filters.push(filterForType(type, value))
  }
  public withSize(size) {
    this.size = size
    return this
  }
  public withPageSize(size) {
    this.size = size
    this.offset = this.page * size - size
    return this
  }
  public onPage(page) {
    this.page = page
    this.offset = page * this.size - this.size
    return this
  }
}
